module.exports = __webpack_public_path__ + "static/media/ST.67ce4c81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ST.svg
// module id = 365
// module chunks = 0